import styled from 'styled-components';

export const Container = styled.div`
  .modal-header {
    background-color: ${(props) => props.theme.$dark};
    color: ${(props) => props.theme.$white};
  }

  .modal-footer {
    justify-content: center !important;
  }

  .modal-title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
  }

  .close {
    color: ${(props) => props.theme.$white};
  }

  label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  input {
    background: #ffffff;
    border: 1px solid #dfdfdf;
    border-radius: 4px;
  }

  .feedback-error {
    color: #c62828;
    font-size: 13px;
  }
`;

export const Hint = styled.p`
  font-size: 13px;
`;
